import React, { type ReactNode } from "react";
import { EditBase, type RaRecord, useDataProvider, useRecordContext } from "react-admin";
import { FieldValues } from "react-hook-form";
import { Form2 } from "./Form2";

export function EditForm2<T extends RaRecord = any>({
  resource,
  id,
  children,
  onError,
  onSuccess,
}: {
  resource: string;
  id: T["id"];
  children: ReactNode;
  onError?: (error: any) => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}) {
  return (
    <EditBase<T> resource={resource} id={id}>
      <_LazyForm2 resource={resource} onError={onError} onSuccess={onSuccess}>
        {children}
      </_LazyForm2>
    </EditBase>
  );
}

function _LazyForm2({
  resource,
  children,
  onError,
  onSuccess,
}: {
  resource: string;
  children: ReactNode;
  onError?: (error: any) => any;
  onSuccess: () => any;
}) {
  const dataProvider = useDataProvider();
  const record = useRecordContext();

  if (!record) {
    return null;
  }

  const onSubmit = async (formData: FieldValues, event?: React.BaseSyntheticEvent) => {
    event?.preventDefault();
    await runSafely(() => dataProvider.update(resource, { id: record.id, data: formData, previousData: record }), {
      onError,
      onSuccess,
    });
  };

  return <Form2 onSubmit={onSubmit}>{children}</Form2>;
}
